const translations = {
    boundary: 'Boundary',
    boundaryIsRequired: 'Boundary is required'
};

export default translations;
